import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=097bfb8a&scoped=true&"
import script from "./SelectComponent.vue?vue&type=script&lang=js&"
export * from "./SelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectComponent.vue?vue&type=style&index=0&id=097bfb8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097bfb8a",
  null
  
)

export default component.exports